import createHasSubmitSucceeded from './selectors/hasSubmitSucceeded';
import plain from './structure/plain';
export default createHasSubmitSucceeded(plain);


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/hasSubmitSucceeded.js
// module id = 2124
// module chunks = 1